<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.title" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="title" /><!--
          --><checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.actions" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="actions" /><!--
          --><checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.text" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="text" />
        </test-toolbar>
      </flex-col>
      <flex-col equal-height :span="6" v-for="guitar in 4" md4 sm12 xs24 :key="`guitar-${guitar}`">
        <card full-height>
          <card-title v-if="title" :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" color="white" v-html="$lang.cardTitle" />
          <card-text padding-off v-if="text">
            <lazy-image
              :placeholder-bg-color="$dark ? 'black' : 'white'"
              :placeholder-bg-color-lightness="null"
              :placeholder-icon-color="$root.colors.primary"
              :placeholder-icon-color-lightness="$root.colors.bgColorLightness"
              :src="`${$root.config.staticAssetsDir}/images/guitars/strandberg-boden-prog-7/image-0${guitar}.jpg`" />
          </card-text>
          <card-actions v-if="actions" >
            <btn plain :color="$root.colors.primary" :color-lightness="null" size="sm">{{ $lang.cancel }}</btn>
            <btn :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" color="white" size="sm">{{ $lang.ok }}</btn>
          </card-actions>
        </card>
      </flex-col>
      <flex-col equal-height :span="6" v-for="lorem in 4" md4 sm12 xs24 :key="`lorem-${lorem}`">
        <card full-height>
          <card-title v-if="title" :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" color="white" v-html="$lang.cardTitle" />
          <card-text v-if="text">
            <lorem-ipsum />
          </card-text>
        </card>
      </flex-col>
    </flex>
  </container>
</template>
<script>
export default {
  name: 'PageCard',
  data () {
    return {
      title: true,
      actions: true,
      text: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/card.vue